export default function ValueProposition() {
  return (
    <section className="grid md:grid-cols-2 min-h-screen">
      <div className="relative bg-[#E8E3D6] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/c52b9d157ecdd5335bb22df7656c6140.jpg"
          alt="Metodología de enseñanza"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-0 left-0 p-12 text-left">
          <p className="text-sm font-normal tracking-[0.15em] text-gray-600 mb-3 uppercase">
            Metodología
          </p>
          <h2 className="font-extrabold text-black leading-[1.1]">
            <div className="text-6xl">APRENDE</div>
            <div className="text-5xl mt-1">A PENSAR</div>
            <div className="text-[42px] mt-1">COMO EXPERTO</div>
          </h2>
        </div>
      </div>

      <div className="bg-white flex items-center justify-center px-12 md:px-20 py-20">
        <div className="max-w-[520px] text-center">
          <h3 className="text-5xl font-bold text-black mb-8">
            8 Módulos Progresivos de Formación Integral
          </h3>
          <p className="text-lg text-gray-700 leading-[1.7] mb-12">
            Desde anatomía funcional y biomecánica aplicada hasta programación avanzada y nutrición deportiva. 
            Cada módulo está diseñado para construir conocimiento sólido, no solo memorizar ejercicios. 
            Aprenderás a analizar, adaptar y diseñar entrenamientos basados en principios fisiológicos reales.
          </p>
          <a
            href="#modulos"
            className="inline-block px-10 py-4 bg-[#1A3A2E] text-white font-medium rounded-full hover:bg-[#2A4A3E] transition-all cursor-pointer whitespace-nowrap"
          >
            Explorar Módulos →
          </a>
        </div>
      </div>
    </section>
  );
}
